const PREVIEW_STORAGE_KEY = 'strapi-preview';

export type PreviewStatus = 'draft' | 'published';

export type PreviewConfig = {
  active: boolean;
  status: PreviewStatus;
};

const parsePreviewStatus = (value: string | null): PreviewStatus =>
  value === 'draft' ? 'draft' : 'published';

export const initPreviewFromUrl = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  const url = new URL(window.location.href);
  const secret = url.searchParams.get('secret');
  const status = url.searchParams.get('status');
  const previewSecret = import.meta.env.VITE_PREVIEW_SECRET;

  if (secret && previewSecret && secret === previewSecret) {
    sessionStorage.setItem(
      PREVIEW_STORAGE_KEY,
      JSON.stringify({
        active: true,
        status: parsePreviewStatus(status),
      }),
    );

    url.searchParams.delete('secret');
    url.searchParams.delete('status');
    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    return;
  }

  if (!previewSecret && secret) {
    console.error('VITE_PREVIEW_SECRET is not defined: preview mode cannot be activated.');
  }
};

export const getPreviewConfig = (): PreviewConfig => {
  if (typeof window === 'undefined') {
    return { active: false, status: 'published' };
  }

  const stored = sessionStorage.getItem(PREVIEW_STORAGE_KEY);

  if (!stored) {
    return { active: false, status: 'published' };
  }

  try {
    const parsed = JSON.parse(stored) as PreviewConfig;
    return {
      active: Boolean(parsed.active),
      status: parsePreviewStatus(parsed.status),
    };
  } catch {
    return { active: false, status: 'published' };
  }
};

export const isPreviewActive = (): boolean => getPreviewConfig().active;

export const getPreviewSecret = (): string | undefined => {
  if (!isPreviewActive()) {
    return undefined;
  }

  return import.meta.env.VITE_PREVIEW_SECRET;
};
